import React, { useEffect, useRef, useState } from 'react';
import { Card, Col, Container, Image, Row } from 'react-bootstrap';
import { Toast } from 'primereact/toast';
import LiveTickerBar from '../../../components/live-ticker-bar/liveTickerBar';
import "nouislider/distribute/nouislider.css";
import DataTableComponent from '../../../components/dataTables/dataTable';
import COLORS from '../../../constants/color';
import lodash, { set } from 'lodash';
import NumberFormatter from '../../../formatters/NumberFormatter'
import Spinner from '../../../components/spinner';
import moment from 'moment';
import TechnicalAnaysis from '../../../components/stockSubScreens/technicalAnalysis/TechnicalAnalysisDaily';
import { IndexAnalysisServiceApi } from "../../../services/marketQuery/api";
import { Configuration } from "../../../services/marketQuery/configuration"
import { ScoreApi } from "../../../services/score/api";
import { Configuration as ScoreConfiguration } from "../../../services/score/configuration"
import { IndexServiceApi, CustomAnalysisServiceApi, RatioScoreServiceApi, ContentServiceApi, IndexContentServiceApi } from "../../../services/actionHub/api";
import { Configuration as ActionHubConfiguration } from "../../../services/actionHub/configuration"
import { KapApi } from "../../../services/news/api";
import { Configuration as NewsConfiguration } from "../../../services/news/configuration"
import BlinkerBar from '../../../components/blinker';
import bear from '../../../assets/img/bear.png'
import bearDark from '../../../assets/img/bear-dark.png'
import bull from '../../../assets/img/bull.png'
import bullDark from '../../../assets/img/bull-dark.png'
import bullandbear from '../../../assets/img/bullandbear.png'
import News from '../../news/news';
import ScoreLineChart from '../../../components/charts/scoreCharts/scoreLineChart';
import GaugeBar from '../../../components/gaugeBars/gaugeBar';
import Streaming from '../../../services/_realtime/price/Streaming';
import { APIControl } from '../../../helpers/APIControl';
import WatchlistTable from '../../watchlist/components/table';
import IndexAnalysisTable from './components/IndexAnalysisTable';
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import IndexHeaderBar from './components/indexHeaderBar';
import ScoreBarChart from '../../stockAnalysis/indicators/ScoreBarChart';
import ErrorView from '../../../components/alert/error-view';
import { setSelectedItem } from "../../../stores/selectedItemSlice";

const IndexAnalysis = () => {
    const dispatch = useDispatch();
    const selectedIndexFromStore = useSelector((state) => state.selectedItem.selectedItem);
    const streamingRef = useRef(null);
    const streamingUnSub = useRef(null);
    const numberFormatter = new NumberFormatter();
    const marketApi = new IndexAnalysisServiceApi(new Configuration({ basePath: process.env.REACT_APP_MARKET_QUERY_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_MARKET_QUERY_API_BASE_PATH));
    const scoreApi = new ScoreApi(new ScoreConfiguration({ basePath: process.env.REACT_APP_SCORE_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_SCORE_API_BASE_PATH));
    const actionHubIndexApi = new IndexServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const actionHubContentApi = new ContentServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const actionHubIndexContentApi = new IndexContentServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const actionHubRatioScoreServiceApi = new RatioScoreServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const customAnalysisApi = new CustomAnalysisServiceApi(new ActionHubConfiguration({ basePath: process.env.REACT_APP_ACTION_HUB_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_ACTION_HUB_API_BASE_PATH));
    const newsApi = new KapApi(new NewsConfiguration({ basePath: process.env.REACT_APP_NEWS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_NEWS_API_BASE_PATH));
    const toast = useRef(null);
    const [indexButtons, setIndexButtons] = useState([]);
    const [bullAndBearButtons, setBullAndBearButtons] = useState([]);
    const [ActiveBullAndBear, setActiveBullAndBear] = useState(1);
    const [activeIndex, setActiveIndex] = useState(1);
    const [bullAndBearDetail, setBullAndBearDetail] = useState({});
    const [IndexPageTitle, setIndexPageTitle] = useState('BIST 100');
    const [sliderValue, setSliderValue] = useState([184.23, 255.40]);
    const [sliderRange, setSliderRange] = useState({ min: [117.69], max: [302.69], avg: [184.07], last: [255.40] });
    const [livegridData, setlivegridData] = useState([]);
    const [columnsData, setColumnsData] = useState([]);
    const [stateNewsCategoryActive, setStateNewsCategoryActive] = useState([{ id: 1 }]);
    const [engagingBar, setEngagingBar] = useState([]);
    const [activeNewsCategory, setActiveNewsCategory] = useState(1);
    const [newsTableData, setNewsTableData] = useState([]);
    const [showTechnicalAnalysisSubScreen, setShowTechnicalAnalysisSubScreen] = useState(false);
    const [showDefaultScreen, setShowDefaultScreen] = useState(true);
    const [marketAnalysisData, setMarketAnalysisData] = useState([]);
    const [actionHubIndexData, setActionHubIndexData] = useState([]);
    const [indexList, setIndexList] = useState([]);
    const [selectedIndex, setSelectedIndex] = useState();
    const [selectedIndexCode, setSelectedIndexCode] = useState("XU100");
    const [marketIndexAnalysisTableData, setMarketIndexAnalysisTableData] = useState([]);
    const token = localStorage.getItem('token');
    const [isLoadingLineChart, setIsLoadingLineChart] = useState(true);
    const [isLoadingNews, setIsLoadingNews] = useState(true);
    const [isLoadingTable, setIsLoadingTable] = useState(true);
    const [isLoadingGaugeBar, setIsLoadingGaugeBar] = useState(true);
    const [objectIds, setObjectIds] = useState([]);
    const [actionHubContentData, setActionHubContentData] = useState([]);
    const [bullAndBearDataId, setBullAndBearDataId] = useState();
    const [scoreIGaugeData, setScoreIGaugeData] = useState([]);
    const [newsEntityIds, setNewsEntityIds] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [symbolListData, setSymbolListData] = useState([]);
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const [entityId, setEntityId] = useState(selectedIndexFromStore?.entityId);
    const { t, i18n } = useTranslation();
    const [showConstAnaysisAdvice, setShowConstAnaysisAdvice] = useState(false);
    const language = i18n.language;

    const [indicatorChartType, setIndicatorChartType] = useState('lineChart');
    //#region DataGrid
    const columns = [
        // { id: 0, field: 'search', displayName: 'W', header: 's', isVisible: true, width: "0px" },
        { id: 2, field: 'searchableHeader', displayName: 'Sembol', header: '', filterField: "name", isFrozen: true, format: "code-s-f-t", isVisible: true, align: 'left', width: '1%', paddingRight: '0px', sortable: false },
        // { id: 0, field: 'fav', displayName: 'Favoriler', header: '', isVisible: true, align: 'left', width: '1%' },
        // { id: 2, field: 'code', displayName: 'Hisse Kodu', header: '', isVisible: true, align: 'left', width: '10%', clikable: true },
        // { id: 3, field: 'name', displayName: 'Hisse Adı', header: '', isVisible: true, width: '33%', align: 'left' },
        // { id: 4, field: 'technicalAnalysis', displayName: 'Teknik Analiz', header: '', isVisible: true, },
        { id: 5, field: 'indicators', displayName: 'İndikatörler', header: t('tableHeader.indicators'), isVisible: true, align: 'center', },
        { id: 6, field: 'dailyChange', displayName: 'Değişim', header: t('tableHeader.change'), template: '', isVisible: true, align: 'center' },
        { id: 7, field: 'lastPrice', displayName: 'Son', header: t('tableHeader.last'), template: '', width: '33%', isVisible: true, align: 'right' },
        { id: 8, field: 'bid', displayName: 'Alış Fiyatı', header: t('tableHeader.buying'), template: '', width: '33%', isVisible: true, align: 'right' },
        { id: 9, field: 'ask', displayName: 'Satış Fiyatı', header: t('tableHeader.Satış'), template: '', width: '33%', isVisible: true, align: 'right' },
        { id: 12, field: 'range52w', displayName: '52 Haftalık Değişim', header: t('tableHeader.52WeekRange'), template: '', isVisible: true, },
        { id: 10, field: 'indexWeight', displayName: 'Endeks Ağırlığı', header: t('tableHeader.indexWeight'), width: '40%', template: '', isVisible: true, sortable: true, align: 'right' },
    ];

    const newsCategories = [
        {
            id: "FinansalRaporlar",
            name: t('news.categories.financialReports'),
            code: "FinansalRaporlar"
        },
        {
            id: "VergiBilancolari",
            name: t('news.categories.taxBalanceSheets'),
            code: "VergiBilancolari"
        },
        {
            id: "TemettuveSermayeArttirimi",
            name: t('news.categories.dividendAndCapitalIncrease'),
            code: "TemettuveSermayeArttirimi"
        },
        {
            id: "OzelDurumAciklamalari",
            name: t('news.categories.specialCaseDisclosures'),
            code: "OzelDurumAciklamalari"
        },
        {
            id: "Diğer",
            name: t('news.categories.other'),
            code: "Diger"
        },
    ];
    //#endregion DataGrid


    //#region SubScreenData

    //#endregion SubScreenData

    useState(() => {
        setColumnsData(columns);
        // setlivegridData(liveData);
        // setEngagingBar(engagingBarData);
        // setNewsTableData(newsData);
    }, [])


    useEffect(() => {
        if (selectedIndex) {
            setEntityId(selectedIndex.entityId);
        }
    }, [selectedIndex])

    useEffect(() => {
        getActionHubStockIndexData();

    }, [])

    useEffect(() => {
        if (selectedIndexFromStore) {
            setSelectedIndex(selectedIndexFromStore);
        }
    }, [selectedIndexFromStore]);

    useEffect(() => {
        if (selectedIndex) {
            dispatch(setSelectedItem(selectedIndex)); // Store selectedIndex in Redux
            setIsLoadingTable(true);

            getIndexAnalysis(selectedIndex.entityId); // Pass entityId
            setActiveNewsCategory(newsCategories[0]);
            getBullAndBearData();
        }
    }, [selectedIndex])

    useEffect(() => {
        // console.log('selectedIndex useEffect', selectedIndex);

        if (selectedIndex) {
            setIsLoadingTable(true);

            getIndexAnalysis(selectedIndex.entityId); // Pass entityId
            setActiveNewsCategory(newsCategories[0]);

            getBullAndBearData();

        }
    }, [selectedIndex])

    useEffect(() => {
        // This effect should only run when the default screen is active.
        if (bullAndBearDataId !== undefined && selectedIndex && showDefaultScreen) {
            getActionHubContentData();
            getGaugeBarScoreData();
            getLineChartData();
        }
    }, [bullAndBearDataId, selectedIndex, showDefaultScreen]);

    useEffect(() => {

        if (objectIds.length > 0) {
            if (!streamingRef.current) {
                streamingRef.current = new Streaming();
                // const mappedObjectIDs = lodash.map(marketIndexAnalysisTableData, 'objectID');
                streamingUnSub.current = streamingRef.current.subscribe({ objectIds: objectIds }, (data) => {
                    processStreamingData(data);
                });
                // İsteğe bağlı: bileşen kaldırıldığında temizleme yap
                return () => {
                    if (streamingRef.current) {
                        streamingUnSub.current.Dispose()
                        //// console.log('streamingRef.current', streamingRef.current);
                    }
                };
            }
        }

    }, [objectIds])

    useEffect(() => {
        const handleReload = () => {

            console.log("Reloading data...");
            const currentSelectedIndex = selectedIndex || selectedIndexFromStore; // Use Redux store as fallback
            if (currentSelectedIndex && currentSelectedIndex['entityId']) {
                getIndexAnalysis(currentSelectedIndex['entityId']); // Pass entityId
            } else {
                console.error("Selected index is null or invalid.");
            }
        };

        window.addEventListener("reloadData", handleReload);

        return () => {
            window.removeEventListener("reloadData", handleReload);
        };
    }, [selectedIndex, selectedIndexFromStore]);

    const getIndexAnalysis = (entityId) => {
        setIsLoadingTable(true); // Show spinner before data reload
        const culture = language;


        marketApi.marketIndexanalysisGet(token, entityId, culture).then((res) => {
            if (res.data.error) {
                toast.current.show({ severity: 'error', summary: t('error'), detail: res.data.error, life: 3000 });
                setSymbolListData([]);
                setIsLoadingTable(false);
                return;
            }

            let data = res.data.item;

            if (!data || data.length === 0) {
                setSymbolListData([]);
                // toast.current.show({ severity: 'info', summary: t('info'), detail: t('noDataForSymbol'), life: 3000 });
                setIsLoadingTable(false); // Hide spinner
                return;
            }

            setMarketAnalysisData(data);
            setObjectIds(lodash.map(data, 'entityId'));
            setSymbolListData(data);

            for (let i = 0; i < data.length; i++) {
                let element = data[i];
                element['@'] = element.entityId;
                element.lastPrice = 0;
                element.buy = 0;
                element.ask = 0;
                element.bid = 0;
                element.dailyChange = 0;
                element.dailyChangeColor = 'grey';
                for (let j = 0; j < data[i].indicators.length; j++) {
                    const element = data[i].indicators[j];
                    element.color = "#1F7C03";

                    if (element.color === "green") {
                        element.color = "#1F7C03";
                    } else if (element.color === "red") {
                        element.color = "#9F2007";
                    } else if (element.color === "yellow") {
                        element.color = "#B7B7B7";
                    } else if (element.color === "orange") {
                        element.color = "#FFA500";
                    } else if (element.color === "blue") {
                        element.color = "#0000FF";
                    }
                }
            }

            setTimeout(() => {
                setMarketIndexAnalysisTableData(data);
                setIsLoadingTable(false); // Hide spinner
            }, 1000);
        }).catch((err) => {
            console.error(err);
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('errorOccurred'), life: 3000 });
            setSymbolListData([]); // Clear data
            setIsLoadingTable(false); // Hide spinner
        });
    }

    //#region Click Bull And Bear
    const clickBullAndBear = (item) => {
        // Update state with the selected bull and bear data
        console.log('clickBullAndBear: ', item);
        setActiveBullAndBear(item.id);
        setBullAndBearDetail(bullAndBearButtons.find(x => x.id === item.id));
        setBullAndBearDataId(bullAndBearButtons.find(x => x.id === item.id).fieldId);
        setIndicatorChartType(item.chartType);

        // Store selected indicator in localStorage
        localStorage.setItem('selectedIndicatorId', item.id);
        localStorage.setItem('selectedIndicatorScoreCode', item.scoreCode);

        // Determine which screen to show based on the selected item
        const TECHNICAL_IDS = ["MA", "Technical"];
        const CONSENSUS_RESEARCH_CONDITION = item.scoreCode === "Consensus_Research";

        if (CONSENSUS_RESEARCH_CONDITION) {
            // Show ConsAnalysisAdvice for Consensus_Research
            setShowDefaultScreen(false);
            setShowTechnicalAnalysisSubScreen(false);
            setShowConstAnaysisAdvice(true);
        } else if (TECHNICAL_IDS.includes(item.scoreCode)) {
            // Show Technical Analysis SubScreen
            setShowTechnicalAnalysisSubScreen(true);
            setShowDefaultScreen(false);
            setShowConstAnaysisAdvice(false);
        } else {
            // Default screen
            setShowTechnicalAnalysisSubScreen(false);
            setShowDefaultScreen(true);
            setShowConstAnaysisAdvice(false);
        }
    }
    //#endregion Click Bull And Bear

    //#region Click Index
    const clickIndex = (index) => {
        const selected = indexList.find(x => x.entityId === index);
        setActiveIndex(selected);
        setSelectedIndex(selected);
        setIndexPageTitle(selected.name);
        setNewsEntityIds(selected.entityId);
        setSelectedIndexCode(selected.code);
        dispatch(setSelectedItem(selected)); // Update Redux store
        getIndexAnalysis(selected.entityId); // Pass entityId
    }
    //#endregion Click Index

    //#region ParallelButtonSelection

    const clickNewsCategory = (title) => {
        setIsLoadingNews(true);
        setActiveNewsCategory(title);
        getNewsData(title)

    }
    //#endregion ParallelButtonSelection

    //#region API Calls

    //#region ACTION HUB STOCK INDEX EFFECT

    const getActionHubStockIndexData = () => {

        customAnalysisApi.actionhubCustomanalysisindexesGet(token).then((res) => {
            setActionHubIndexData(res.data.indexes);


            // const indexListData = lodash.map(res.data.indexes, (res) => ({
            //     name: res['name'].trTr,
            //     nameEnUs: res['name'].enUs,
            //     code: res.code,
            //     entityId: res.entityId,
            // }));

            let indexListData = [];
            res.data.indexes.forEach((res) => {
                let obj = {};
                obj.name = res['name'].trTr;
                obj.nameEnUs = res['name'].enUs;
                obj.code = res.code;
                obj.entityId = res.entityId

                if (res.entityId === 'sec.101.417')
                    obj["order"] = 1;
                else if (res.entityId === 'sec.101.411')
                    obj["order"] = 2;
                else if (res.entityId === 'sec.101.409')
                    obj["order"] = 3;
                else if (res.entityId === 'sec.101.29976')
                    obj["order"] = 4;
                else if (res.entityId === 'sec.101.29974')
                    obj["order"] = 5;
                else if (res.entityId === 'sec.101.911')
                    obj["order"] = 6;
                else if (res.entityId === 'sec.101.912')
                    obj["order"] = 7;
                else if (res.entityId === 'sec.101.38594')
                    obj["order"] = 8;
                else if (res.entityId === 'sec.101.402')
                    obj["order"] = 9;
                else if (res.entityId === 'sec.101.394')
                    obj["order"] = 10;
                else if (res.entityId === 'sec.101.393')
                    obj["order"] = 11;
                else
                    obj["order"] = 11;

                indexListData.push(obj);
            });

            indexListData.sort((a, b) => a.order - b.order);


            setIndexList(indexListData);

            if (indexListData.length > 0) {
                const index = lodash.findIndex(indexListData, { entityId: 'sec.101.411' }); // BIST 100
                if (index !== -1) {
                    setActiveIndex(indexListData[index]);
                    setSelectedIndex(indexListData[index]);
                    setIndexPageTitle(indexListData[index].name);
                    setNewsEntityIds(indexListData[index].entityId);
                    setSelectedIndexCode(indexListData[index].code);
                }
                else {
                    setActiveIndex(indexListData[0]);
                    setSelectedIndex(indexListData[0]);
                    setIndexPageTitle(indexListData[0].name);
                }
            }
        })
        //// console.log(indexListData);
    }
    //#endregion ACTION HUB STOCK INDEX EFFECT

    //#region ACTION HUB CONTENT

    const getActionHubContentData = () => {
        const entityId = selectedIndex['entityId'];
        const culture = language;
        const dataId = bullAndBearDataId;

        actionHubIndexContentApi.actionhubIndexcontentGet(token, entityId, culture, dataId).then((res) => {
            if (res.data.error) {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.chartDataFetchError'), life: 3000 });
                setActionHubContentData("Error");
                return;
            }

            setActionHubContentData(res.data.content);

        }).catch((err) => {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.dataLoadFailed'), life: 3000 });
        });
    }

    //#endregion ACTION HUB CONTENT

    //#region  GAUGE BAR - SCORE API

    const getGaugeBarScoreData = () => {
        setIsLoadingGaugeBar(true);

        let requestBody = {
            "queries": [
                {
                    "entityId": selectedIndex['entityId'],
                    "gauageFieldId": bullAndBearDataId,
                    "currencyId": getCurrencyId()
                }
            ]
        }
        scoreApi.scoreIGaugeDataPost(token, requestBody).then((res) => {

            const data = res.data.securityGaugeResult[0];

            if (data) {
                data.min = parseFloat(data.min.toFixed(2));
                data.max = parseFloat(data.max.toFixed(2));
                data.average = parseFloat(data.average.toFixed(2));
                data.last = parseFloat(data.last.toFixed(2));

                // Handle renklerini sabit tut: 0 -> ortalama, 1 -> son
                setSliderValue([data.average, data.last]);
                setSliderRange({ min: [data.min], max: [data.max], avg: [data.average], last: [data.last] });

                let scoreIGaugeData = [
                    {
                        key: 'min',
                        name: t('technicalAnalysis.minimum'),
                        value: data.min,
                        color: COLORS.lowerRed,
                    },
                    {
                        key: 'max',
                        name: t('technicalAnalysis.maximum'),
                        value: data.max,
                        color: COLORS.biggestColor,
                    },
                    {
                        key: 'avg',
                        name: t('technicalAnalysis.average'),
                        value: data.average,
                        color: COLORS.avgColor,
                    },
                    {
                        key: 'last',
                        name: t('technicalAnalysis.last'),
                        value: data.last,
                        color: COLORS.lastColor,
                    }
                ]
                setScoreIGaugeData(scoreIGaugeData);
            }

            setTimeout(() => {
                setIsLoadingGaugeBar(false);
            }, 1000);

        }).catch((err) => {
            setIsLoadingGaugeBar(false);
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.gaugeDataFetchError'), life: 3000 });
        });
    }

    //#endregion GAUGE BAR - SCORE API


    const getCurrencyId = () => {

        return bullAndBearDetail.scoreCode == "close" ? 2 : 1;
    }

    //#region LINE CHART - SCORE API

    const getLineChartData = () => {
        setIsLoadingLineChart(true);

        let requestBody = {
            "queries": [
                {
                    "entityId": selectedIndex['entityId'],
                    "fieldId": bullAndBearDataId,
                    "currencyId": getCurrencyId()
                }
            ]
        }

        scoreApi.scoreIHistoryDataPost(token, requestBody).then((res) => {
            if (res.data.error) {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.chartDataFetchError'), life: 3000 });
                setIsLoadingLineChart(false);
                return;
            }

            const data = res.data.securityHistoryResult;

            let formattedDates = res.data.securityHistoryResult.map(item => {
                return {
                    ...item,
                    date: indicatorChartType === 'lineChart'
                        ? new Date(moment(String(item.date), "YYYYMMDD")).getTime()
                        : item.date
                };
            });

            setChartData(formattedDates);

            setTimeout(() => {
                setIsLoadingLineChart(false);
            }, 1000);
        }).catch((err) => {
            setIsLoadingLineChart(false);
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.chartDataFetchError'), life: 3000 });
        });
    }

    //#endregion LINE CHART - SCORE API

    //#region BULL AND BEAR - ACTION API

    const getBullAndBearData = () => {

        let entityId = selectedIndex['entityId'];

        actionHubRatioScoreServiceApi.scoreRatioScoreGet(token, entityId, i18n.language).then((res) => {

            if (res.data.error) {
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.gaugeDataFetchError'), life: 3000 });
                setBullAndBearButtons([]);
                return;
            }
            // let data = (lodash.sortBy(res.data.Ratioscore, 'order'));
            let data = lodash.map(res.data.Ratioscore, (res, index) => ({
                id: index + 1,
                scoreCode: res.scoreCode,
                scoreName: res.scoreName,
                score: res.score,
                order: res.order,
                fieldId: res.fieldId,
                detail: res.detail ? res.detail : 'res.data.Ratioscore.detail not found',
                chartType: res.chartType,
                criterian: res.criterian,
            })).sort((a, b) => a.order - b.order);

            // Filter out "MA" and "Technical" in production
            const isProd = false; // process.env.REACT_APP_IS_PROD === 'true';
            const TECHNICAL_IDS = ["MA", "Technical"];
            if (isProd) {
                data = data.filter(item => !TECHNICAL_IDS.includes(item.scoreCode));
            }

            setBullAndBearButtons(data);


            let orderIndex = data.map(x => x.order)[0];

            if (orderIndex !== -1) {

                let item = data.find(x => x.order === orderIndex);

                if (item) {
                    setBullAndBearDataId(item.fieldId);
                    setActiveBullAndBear(item.id);
                    setBullAndBearDetail(item);
                }
                else {
                    console.log('item not found');
                    toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.itemNotFound'), life: 3000 });
                }
            }
            else {
                console.log('orderIndex not found');
                toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.orderIndexNotFound'), life: 3000 });
            }
        }
        ).catch((err) => {
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.dataLoadFailed'), life: 3000 });
        });
    }
    //#endregion BULL AND BEAR - ACTION API

    //#region INDEX ANALYSIS 

    //#endregion INDEX ANALYSIS 

    //#region NEWS API

    const getNewsData = (category) => {

        let newsTypes = [category.code]

        let limit = 20

        let offset = 0;

        let securityCodes = [];

        let beginOfDate = moment().add("y", -1).format("YYYY-MM-DD");

        let constutientEntityId = "XU100";


        newsApi.apiKapNewsGet(constutientEntityId, newsTypes, beginOfDate, token, securityCodes, limit, offset).then((res) => {
            // console.log(res.data.data);
            setNewsTableData(res.data.data);
            setTimeout(() => {
                setIsLoadingNews(false);
            }, 1000);

        }
        ).catch((err) => {
            setIsLoadingNews(false);
            toast.current.show({ severity: 'error', summary: t('error'), detail: t('componentErrors.dataLoadFailed'), life: 3000 });
        });
    }

    //#endregion NEWS API

    //#region  REAL TIME 

    const processStreamingData = (msg) => {
        // console.log('IndexAnalysis processStreamingData', msg);
        var cmd = msg['@'];

        if (cmd == undefined) return;

        if (cmd == 'heartbeat') {
            return;
        }
        if (cmd == 'handshake' || cmd == 'Handshake') {
            return;
        }

        if (cmd == undefined) {
            return;
        }

        // console.count('setMarketIndexAnalysisTableData');
        setMarketIndexAnalysisTableData((prevData) => {
            if (prevData.length === 0) {
                return prevData;
            }

            const existingObjectIndex = prevData.findIndex((obj) => obj['@'] === msg['@']);
            // msg.lastPrice = numberFormatter.Double(msg.lastPrice, 2);
            let newData;

            if (existingObjectIndex !== -1) {
                newData = prevData.map((item) => {
                    if (item['@'] === msg['@']) {
                        if (msg.dailyChange) {
                            if (msg.dailyChange == 0) {
                                msg.dailyChangeColor = 'grey';
                            }
                            else if (item.dailyChange > msg.dailyChange) {
                                msg.dailyChangeColor = 'red';
                            }
                            else if (item.dailyChange < msg.dailyChange) {
                                msg.dailyChangeColor = 'green';
                            }
                            else {
                                msg.dailyChangeColor = 'green';
                            }
                            item = { ...item, dailyChange: msg.dailyChange, dailyChangeColor: msg.dailyChangeColor };
                        }
                        if (msg.lastPrice) {
                            item = { ...item, lastPrice: msg.lastPrice, };
                        }
                        if (msg.ask) {
                            item = { ...item, ask: msg.ask, };
                        }
                        if (msg.bid) {
                            item = { ...item, bid: msg.bid, };
                        }
                    }
                    return item;

                });
                return newData;

            }
            else {
                if (msg.dailyChange) {

                    if (msg.dailyChange > 0) {
                        msg.dailyChangeColor = 'green';
                    }
                    else if (msg.dailyChange < 0) {

                        msg.dailyChangeColor = 'red';
                    }
                    else {
                        msg.dailyChangeColor = 'grey';
                    }
                    // msg.dailyChange = numberFormatter.Double(msg.dailyChange, 2);
                }
                setTimeout(() => {
                    // setIsLoadingGainersTable(false);
                }, 1000);
                return [...prevData, msg];
            }


        });
    }

    //#endregion REAL TIME

    //#endregion API Calls

    return (

        <div className='index-analysis-screen'>
            <Toast ref={toast} position='bottom-right' />

            {/* LiveTickerBar */}
            <Container>
                <Row>
                    <Col>
                        <LiveTickerBar />

                    </Col>
                </Row>
            </Container>
            {/* LiveTickerBar */}

            {/* Divider */}
            <div className='divider-green' ></div>
            {/* Divider */}

            {/* Index Button */}
            <div className='index-buttons-container m-t-20'>
                {
                    indexList.map((item, index) => (
                        <div
                            className={`index-button roboto-bold-14 ${activeIndex.entityId === item.entityId ? 'active' : ''}`}
                            onClick={() => clickIndex(item.entityId)}
                            key={item.entityId}
                        >
                            {item.name}</div>
                    ))
                }
            </div>
            {/* Index Button */}

            {/* Symbol Bar */}

            <IndexHeaderBar selectedIndex={selectedIndex && selectedIndex.entityId} />

            {/* Bull and Bear */}
            <div className='bull-and-bear-container m-t-20'>
                {
                    bullAndBearButtons.map((item, index) => (
                        <div
                            key={item.id}
                            className={`bull-and-bear-button ${ActiveBullAndBear === item.id ? 'active' : ''}`}
                            onClick={() => clickBullAndBear(item)}
                        >
                            {/* Image centered in flexible space */}
                            <div className='bull-bear-image-wrapper'>
                                <BullorBearofScore bullAndBearDetail={item} imgClassName="bullandbear-image" />
                            </div>

                            {/* Text fixed at bottom */}
                            <div className='bull-bear-text-wrapper'>
                                <div className='roboto-bold-12'>{item.scoreName}</div>
                            </div>
                        </div>
                    ))
                }
            </div>
            {/* Bull and Bear */}

            {/* Bull and Bear Detail */}

            <IndicatorSummary
                bullAndBearDetail={bullAndBearDetail}
                actionHubContentData={actionHubContentData}
            />

            {/* Bull and Bear Detail */}

            {/* Page Index Title Divider */}
            <div className='page-title m-t-30 divider-green'>
                <span className='roboto-bold-16'>{IndexPageTitle} </span>
            </div>
            {/* Page Index Title Divider */}

            {
                showDefaultScreen &&
                <>
                    {/* Chart Boxes  */}

                    <Container className='m-t-30 chart-box-container'>
                        <Row className=''>

                            <Col md='6' sm='12' className='chart-box-col-1'>
                                <div className='engaging-bar-box'>

                                    {isLoadingGaugeBar && <Spinner height="300px" />}
                                    {!isLoadingGaugeBar &&
                                        <GaugeBar gaugeLabel={IndexPageTitle} title={IndexPageTitle} sliderValue={sliderValue} sliderRange={sliderRange} data={scoreIGaugeData} />
                                    }

                                </div>
                            </Col>

                            <Col md='6' sm='12' className='chart-box-col-2'>
                                <div className='chart-box'>
                                    {isLoadingLineChart && <Spinner height="300px" />}
                                    {!isLoadingLineChart &&
                                        // <ScoreLineChart data={chartData} averageValue={sliderRange.avg} divId="indexAnalysisChartData" />
                                        (indicatorChartType === 'lineChart'
                                            ? <ScoreLineChart
                                                data={chartData}
                                                averageValue={sliderRange.avg}
                                                selectedSecurity={selectedIndex ? { code: selectedIndex.code, name: selectedIndex.name } : selectedSecurity}
                                                divId="indexAnalysisChartData"
                                                currencySymbol={getCurrencyId() === 2 ? "$" : "₺"}
                                            />
                                            : <ScoreBarChart
                                                data={chartData}
                                                averageValue={sliderRange.avg}
                                                lastValue={sliderRange.last}
                                                selectedSecurity={selectedIndex ? { code: selectedIndex.code, name: selectedIndex.name } : selectedSecurity}
                                                chartId="secBarChart"
                                                currencySymbol={getCurrencyId() === 2 ? "$" : "₺"}
                                            />)

                                        // (indicatorChartType === 'lineChart'
                                        //     ? "lineChart"
                                        //     :
                                        //     "barChart"
                                        // )
                                    }
                                </div>

                            </Col>

                        </Row>

                    </Container>

                    {/* Chart Boxes  */}

                    {/* DataGrid */}


                    <Card className="grid-card watchlist-table m-t-20">
                        {isLoadingTable && <Spinner height="300px" />}
                        {!isLoadingTable && symbolListData.length === 0 && (
                            <ErrorView message={t('noDataForSymbol')} />
                        )}
                        {!isLoadingTable && symbolListData.length > 0 && (
                            <IndexAnalysisTable symbolListData={symbolListData} />
                        )}
                    </Card>

                    {/* <Card className='grid-card m-t-30 index-analysis-table' style={{ width: '100%' }}>
                        {isLoadingTable && <Spinner height="800px" />}
                        {!isLoadingTable &&
                            <DataTableComponent
                                columnsProp={columnsData}
                                dataProp={marketIndexAnalysisTableData}
                                columnsSelect={false}
                                search={false}
                                absoluteSearch={false} />

                        }
                    </Card> */}
                    {/* DataGrid */}

                    {/* News Grid */}
                    <Container className='m-t-40'>
                        <Row className=''>
                            <Col className='p-0'>
                                <label className='color-text roboto-bold-20'>{t('indexAnalysis.indexNews')}</label>
                            </Col>
                        </Row>
                    </Container>

                    {/* <Container className='m-t-20'>
                        <Row className='m-t-5'>
                            <Col className='p-0'>
                                <ParallelButtonSelection titles={newsCategories} activeTitle={activeNewsCategory} clickTitle={clickNewsCategory} />
                            </Col>
                        </Row>
                    </Container> */}

                    <News constutientEntityId={selectedIndexCode} showLiveTicker={false} />

                    {/* 
                    <Card className='grid-card' style={{ width: '100%' }}>
                        {isLoadingNews && <Spinner height="500px" />}
                        {!isLoadingNews &&
                            <NewsTable tableData={newsTableData} />
                        }
                    </Card> */}
                    {/* News Grid */}
                </>
            }
            {
                showTechnicalAnalysisSubScreen &&
                <>
                    <TechnicalAnaysis
                        entityId={selectedIndex ? selectedIndex.entityId : entityId}
                        selectedSecurity={selectedIndex ? { id: selectedIndex.entityId, code: selectedIndex.code, name: selectedIndex.name } : selectedSecurity}
                        selectedBullAndBearItem={ActiveBullAndBear}
                    />

                </>
            }
        </div>
    )
}

export default IndexAnalysis;




function IndicatorSummary({ bullAndBearDetail, actionHubContentData }) {

    return (
        <Container className="bull-and-bear-detail-container m-t-20">
            <Row>
                <Col md="2" className="m-auto"> {/* Changed from md="1" to md="2" for more space */}
                    <BullorBearofScore bullAndBearDetail={bullAndBearDetail} imgClassName={"d-block m-auto larger-icon"} />
                </Col>

                <Col md="10" className="m-auto"> {/* Changed from md="11" to md="10" */}
                    {/* HTML içeriği tehlikeli olduğu için, veriyi güvenli bir kaynaktan aldığınızdan emin olun */}
                    <label
                        className="roboto-regular-14 m-auto"
                        dangerouslySetInnerHTML={{ __html: actionHubContentData }}
                    />
                </Col>
            </Row>
        </Container>
    );
}

function BullorBearofScore({ bullAndBearDetail, imgClassName }) {
    // score ve criterian'a göre gerçek gösterilecek puanı elde ediyoruz.
    let displayedScore = bullAndBearDetail.score;

    if (bullAndBearDetail.criterian === "LowIsGoodScore") {
        displayedScore = 6 - bullAndBearDetail.score;
    }

    // Add a style object to ensure minimum width for the images
    const imgStyle = { minWidth: '4rem', width: '6rem' };

    return (
        <>
            {/* Çok Zayıf (Very Weak) - Dark Bear */}
            {displayedScore > 5 && displayedScore <= 6 && <Image style={imgStyle} className={imgClassName} src={bearDark} fluid />}

            {/* Zayıf (Weak) - Bear */}
            {displayedScore > 4 && displayedScore <= 5 && <Image style={imgStyle} className={imgClassName} src={bear} fluid />}

            {/* Normal - Bull and Bear */}
            {displayedScore > 3 && displayedScore <= 4 && <Image style={imgStyle} className={imgClassName} src={bullandbear} fluid />}

            {/* Olumlu (Positive) - Bull */}
            {displayedScore > 2 && displayedScore <= 3 && <Image style={imgStyle} className={imgClassName} src={bull} fluid />}

            {/* Çok Olumlu (Very Positive) - Dark Bull */}
            {displayedScore >= 1 && displayedScore <= 2 && <Image style={imgStyle} className={imgClassName} src={bullDark} fluid />}
        </>
    );
}
